<template>
  <div class="banner"></div>
</template>

<script>
export default {
  name: 'Banner',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 500px;
  background: url(../../assets/banner.png) no-repeat top center;
}
</style>
